export default {
	computed:{
		user(){
			return this.$store.getters.user;
		},
		isLoggedIn(){
			return this.$store.getters.isLoggedIn;
		}
	}
}